var map = {
	"./razzo-head-page-1.webp": "0c50",
	"./razzo-head-page-2.webp": "9b60",
	"./razzo-head-page-3.webp": "0a22",
	"./razzo-head-page-4.webp": "8128",
	"./razzo-head-page.webp": "19df",
	"./razzo1.webp": "5194",
	"./razzo2.webp": "9d93",
	"./razzo3.webp": "8c91",
	"./razzo4.webp": "2790",
	"./razzo5.webp": "2f36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2810";